import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { PROFILES_ACTIONS } from "../../../../redux/profiles/actions";
import {
  selectProfiles,
  profileCreating,
  profilesMeta
} from "../../../../redux/profiles/selectors";
import Confirm from "../../../../base/Confirm";
import { dateRender } from "../../../../libs/utils";
import ListView from "../../../../base/ListView";
import { toImmutable } from "../../../../libs/immutable-transformer";
import { getEventProfiles } from "../../../../services/api/events";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { ZONES_ACTIONS } from "../../../../redux/zones/actions";
import { selectZones } from "../../../../redux/zones/selectors";
import {
  profileAttachZone,
  profileDetachZone
} from "../../../../services/api/profiles";

class _Profiles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      baseFilters: toImmutable({
        "page[number]": 1,
        "page[size]": 10,
        sort: "-profiles.updated_at",
        include: "accesses"
      }),
      profiles: [],
      profilesMeta: {},
      allProfiles: [],
      localChecked: []
    };

    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._getEventProfiles = this._getEventProfiles.bind(this);
  }

  static propTypes = {
    profiles: PropTypes.array,
    deleteProfile: PropTypes.func,
    profileCreating: PropTypes.bool,
    profilesMeta: PropTypes.object,
    updateFilters: PropTypes.func,
    event: PropTypes.object,
    updateZoneFilters: PropTypes.func,
    zones: PropTypes.array
  };

  UNSAFE_componentWillMount() {
    this._getEventProfiles();

    this.props.updateZoneFilters({
      "page[number]": 1,
      "page[size]": 50,
      sort: "code",
      "filter[venue_id]": this.props.event.venueId
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {}

  _handleFilterUpdate(filters) {
    this._getEventProfiles(filters);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this profile? This action can not be undone, please make sure no festival is using this profile.",
      {
        title: "Delete Profile",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteProfile(id);
      },
      result => {}
    );
  }

  _handleSubmit(e) {
    e.preventDefault();
    const profile = this.state.selectedProfile;
    this.typeaheadC.clear();

    const newProfiles = [profile].concat(this.state.profiles);
    this.setState({ profiles: newProfiles });
  }

  _getEventProfiles(filters) {
    const useFilters = filters ? filters : this.state.baseFilters;
    getEventProfiles(this.props.event.id, useFilters).then(response => {
      this.setState({
        profiles: response.data,
        profilesMeta: response.meta,
        baseFilters: useFilters
      });
    });
  }

  _handleUpdate(e, profileId, zoneId) {
    const data = {
      zoneId: zoneId,
      eventId: this.props.event.id
    };

    const index = this.state.localChecked.indexOf(profileId + "_" + zoneId);

    if (!e.target.checked) {
      if (index !== -1) {
        this.setState({
          localChecked: this.state.localChecked.filter(
            item => item !== profileId + "_" + zoneId
          )
        });
      }
      profileDetachZone(profileId, data).then(() => this._getEventProfiles());
    } else {
      if (index === -1) {
        this.setState({
          localChecked: [profileId + "_" + zoneId].concat(
            this.state.localChecked
          )
        });
      }
      profileAttachZone(profileId, data).then(() => this._getEventProfiles());
    }
  }

  render() {
    const { baseFilters, profiles, localChecked, profilesMeta } = this.state;
    const { event } = this.props;
    const listViewConf = {
      dataSet: profiles,
      dataMeta: profilesMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "cost",
          value: "Cost",
          sort: "cost"
        },
        {
          key: "costNoShow",
          value: "Cost No Show",
          sort: "costNoShow"
        },
        {
          key: "updatedAt",
          value: "Last Updated",
          sort: "updated_at",
          render: profile => dateRender(profile.updatedAt)
        }
      ],
      customHeaderRenderer: () => (
        <tr>
          <th>Name</th>
          {this.props.zones.map(zone => (
            <th
              key={"zone" + zone.id}
              style={{
                textAlign: "center",
                width: 80 / this.props.zones.length + "%"
              }}
              className="zone"
            >
              {zone.code}
              <small>{zone.name}</small>
            </th>
          ))}
          <th />
        </tr>
      ),
      customRowRenderer: profile => (
        <tr key={"profile" + profile.id}>
          <td>{profile.name}</td>
          {this.props.zones.map(zone => (
            <td
              key={"profile" + profile.id + "zone" + zone.id}
              style={{ textAlign: "center" }}
            >
              <label className="m-checkbox m-checkbox--no-label">
                <input
                  type="checkbox"
                  onChange={e => this._handleUpdate(e, profile.id, zone.id)}
                  checked={
                    localChecked.indexOf(profile.id + "_" + zone.id) > -1 ||
                    (profile.accesses &&
                      profile.accesses
                        .map(access => access.zoneId)
                        .indexOf(zone.id) > -1)
                  }
                />
                <span />
              </label>
            </td>
          ))}
          <td className="text-right" style={{ whiteSpace: "nowrap" }}>
            <button
              className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
              onClick={() => this._handleDelete(profile.id)}
            >
              <span>
                <i className="la la-warning" />
                <span>Delete</span>
              </span>
            </button>
          </td>
        </tr>
      ),
      baseFilters: baseFilters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/events/" + event.id + "/catering"
    };

    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <h3 className="m-portlet__head-text">Profile Access</h3>
                </div>
              </div>

              <div className="m-portlet__head-tools">
                <form onSubmit={this._handleSubmit}>
                  <ul className="m-portlet__nav m--margin-left-20">
                    <li className="m-portlet__nav-item access">
                      <AsyncTypeahead
                        multiple={false}
                        options={this.props.profiles}
                        isLoading={false}
                        placeholder={"Search ..."}
                        minLength={2}
                        labelKey="name"
                        ref={c => {
                          this.typeaheadC = c;
                        }}
                        onSearch={value => {
                          this.props.updateFilters({ "filter[name]": value });
                        }}
                        onChange={value => {
                          this.setState({
                            selectedProfile: value[0]
                          });
                        }}
                      />
                    </li>
                    <li className="m-portlet__nav-item">
                      <button
                        type="submit"
                        className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                        disabled={!this.state.selectedProfile}
                      >
                        <span>
                          <i className="la la-plus" />
                          <span>Add Profile</span>
                        </span>
                      </button>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
            <div className="zonestable">
              <ListView
                inPortlet
                config={listViewConf}
                handleDelete={this._handleDelete}
                handleFilterUpdate={this._handleFilterUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  deleteProfile: id => dispatch(PROFILES_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(PROFILES_ACTIONS.updateFilters(filters)),
  updateZoneFilters: filters => dispatch(ZONES_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    profiles: selectProfiles(state),
    profilesMeta: profilesMeta(state),
    profileCreating: profileCreating(state),
    zones: selectZones(state)
  };
};

const Profiles = connect(mapStateToProps, mapDispatchToProps)(_Profiles);

export default Profiles;
